export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1717667745830-de42bb75a4fa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwzfHx3YXN0ZSUyMHJlY3ljbGluZyUyMGZhY2lsaXR5JTIwZmFjdG9yeXxlbnwwfHx8fDE3OTAzMjAxMTh8MA&ixlib=rb-4.1.0&q=85",
  epr: "https://images.unsplash.com/photo-1763315156830-07870b159121?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHx3YXN0ZSUyMHJlY3ljbGluZyUyMGZhY2lsaXR5JTIwZmFjdG9yeXxlbnwwfHx8fDE3OTAzMjAxMTh8MA&ixlib=rb-4.1.0&q=85",
  solid: "https://images.unsplash.com/photo-1679998873820-fb46bb66dfe2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwxfHx3YXN0ZSUyMHJlY3ljbGluZyUyMGZhY2lsaXR5JTIwZmFjdG9yeXxlbnwwfHx8fDE3OTAzMjAxMTh8MA&ixlib=rb-4.1.0&q=85",
  bwg: "https://images.unsplash.com/photo-1654703681116-3988648da2b6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHw0fHx3YXN0ZSUyMHJlY3ljbGluZyUyMGZhY2lsaXR5JTIwZmFjdG9yeXxlbnwwfHx8fDE3OTAzMjAxMTh8MA&ixlib=rb-4.1.0&q=85",
  circular: "https://images.unsplash.com/photo-1604187351574-c75ca79f5807?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxtYXRlcmlhbCUyMHJlY292ZXJ5JTIwY2lyY3VsYXIlMjBlY29ub215fGVufDB8fHx8MTc5MDMyMDExOHww&ixlib=rb-4.1.0&q=85",
  csr: "https://images.pexels.com/photos/4487484/pexels-photo-4487484.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  operations: "https://images.unsplash.com/photo-1553413077-190dd305871c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwzfHxpbmR1c3RyaWFsJTIwd2FyZWhvdXNlJTIwbG9naXN0aWNzJTIwc29ydGluZ3xlbnwwfHx8fDE3OTAzMjAxMTh8MA&ixlib=rb-4.1.0&q=85",
  technology: "https://images.unsplash.com/photo-1587293852726-70cdb56c2866?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxpbmR1c3RyaWFsJTIwd2FyZWhvdXNlJTIwbG9naXN0aWNzJTIwc29ydGluZ3xlbnwwfHx8fDE3OTAzMjAxMTh8MA&ixlib=rb-4.1.0&q=85",
  facility: "/sample-assets/01-illustrative-modern-material-recovery-facility-with-sorted-bales-and-organised-processing-lanes.webp",
  sorting: "/sample-assets/02-organised-recovery-and-sorting-of-waste-materials.webp",
  materials: "/sample-assets/03-recovered-materials-prepared-for-another-use.webp",
};

export const CREDIBILITY = [
  "Founded by IIM Lucknow alumni",
  "Run by a network of industry veterans",
  "Networks in Gurugram · Dublin · Tbilisi · London · Paris · Abu Dhabi",
];

export const PRACTICES = [
  {
    num: "01",
    slug: "india-and-global-epr",
    title: "India & Global EPR",
    audience: "Producers, brands & exporters",
    summary: "Understand and manage producer responsibility across waste streams and destination markets.",
    points: ["Applicability and registration", "Targets, reporting and certificate procurement", "Market-specific producer status"],
    tag: "All applicable Indian streams",
    image: IMAGES.epr,
    imageCaption: "Illustrative recovery line",
    tagline: "EPR expertise. Across streams. Across borders.",
    who: "Producers, importers, brand owners, manufacturers and exporters shipping into international markets.",
    problems: "Complex registration categories, changing targets, source-data gaps, certificate diligence and market-specific producer status questions.",
    deliverables: [
      "Applicability and registration support across applicable Indian EPR streams",
      "Data reconciliation between sales records and packaging or product masters",
      "Filing documentation and portal return preparation",
      "Processor diligence and certificate provenance review",
      "Market-specific assessments for destination-country obligations",
    ],
    streams: ["Plastic packaging", "E-waste", "Batteries", "Waste tyres", "Used oil", "End-of-life vehicles", "Non-ferrous metals", "Construction and demolition"],
    technology: "The client workspace keeps obligations, filings, certificates, evidence and follow-up actions connected after the advisory work is done.",
    nextStep: "Discuss your EPR obligations",
  },
  {
    num: "02",
    slug: "solid-waste-management",
    title: "Solid Waste Management",
    audience: "Municipalities & institutions",
    summary: "Translate waste rules into workable plans, systems and responsibilities.",
    points: ["Waste assessment and action plans", "Segregation, collection and processing", "Monitoring and service oversight"],
    tag: "SWM Rules 2026 alignment",
    image: IMAGES.solid,
    imageCaption: "Illustrative processing facility",
    tagline: "From the rules to a working waste system.",
    who: "Municipal corporations, urban local bodies, development authorities, industrial zones and institutional townships.",
    problems: "Unclear baselines, fragmented collection systems, weak processing pathways, vendor oversight and reporting that does not reflect field reality.",
    deliverables: [
      "Waste quantification and characterisation studies",
      "Segregation, collection and processing workflow design",
      "Facility sizing and decentralised processing plans",
      "Vendor specifications, service levels and monitoring protocols",
      "Field audit and reporting frameworks",
    ],
    technology: "Digital records can connect site data, collections, destinations, service issues and follow-up ownership across the programme.",
    nextStep: "Discuss a solid waste mandate",
  },
  {
    num: "03",
    slug: "bulk-waste-generators",
    title: "Bulk Waste Generators",
    audience: "Facilities & property portfolios",
    summary: "Establish clear accountability for the waste generated at your buildings and sites.",
    points: ["Applicability and gap assessment", "On-site processing and approved pathways", "Records, training and reporting"],
    tag: "Buildings, campuses & municipal BWG programmes",
    image: IMAGES.bwg,
    imageCaption: "Illustrative on-site segregation",
    tagline: "Know your waste. Own the process. Prove the outcome.",
    who: "Commercial parks, hotels, hospitals, campuses, residential complexes and municipal teams managing bulk generator programmes.",
    problems: "Unclear applicability, wet-waste processing decisions, weak segregation, missing gate records and difficulty proving where each stream went.",
    deliverables: [
      "Site-by-site applicability and operational gap assessment",
      "Wet-waste processing pathway evaluation",
      "Authorised collection and destination workflow design",
      "Daily logbooks, staff training and segregation checks",
      "Registration and audit-readiness documentation",
    ],
    technology: "A BWG logbook can keep site records, collection evidence, destination checks and unresolved actions visible in one place.",
    nextStep: "Discuss your site or portfolio",
  },
  {
    num: "04",
    slug: "circular-economy-advisory",
    title: "Circular Economy Advisory",
    audience: "Businesses & material networks",
    summary: "Build the commercial and operational case for keeping products and materials in use.",
    points: ["Material-flow assessment", "Reuse, take-back and reverse supply chains", "Recycled material sourcing and traceability"],
    tag: "Material flows & recovery networks",
    image: IMAGES.circular,
    imageCaption: "Illustrative circular material",
    tagline: "Keep materials in use. Build the case.",
    who: "Consumer brands, packaging converters, manufacturers, retail networks and material innovators.",
    problems: "Material losses, unclear recovery economics, weak reverse logistics, unverified recycled content and difficulty moving from pilot to operating model.",
    deliverables: [
      "Material-flow mapping and destination assessment",
      "Reuse, take-back and reverse logistics design",
      "Recovered material supplier diligence and traceability framework",
      "Recyclability and packaging rationalisation roadmap",
      "Pilot framework and measurement dashboard",
    ],
    technology: "The technology layer can track material records, chain-of-custody evidence, recovery workflows and programme performance.",
    nextStep: "Explore a circular economy project",
  },
  {
    num: "05",
    slug: "waste-management-csr",
    title: "Waste Management CSR",
    audience: "CSR teams & foundations",
    summary: "Design community waste programmes with a clear need, a credible delivery model and measurable outcomes.",
    points: ["Needs assessment and project design", "Implementation frameworks and budgets", "Monitoring, evaluation and outcomes"],
    tag: "Community programmes & M&E",
    image: IMAGES.csr,
    imageCaption: "Illustrative community logistics",
    tagline: "A waste programme with a purpose. And a way to measure it.",
    who: "Corporate CSR committees, foundations, philanthropic trusts and institutional donors.",
    problems: "Projects chosen before the need is measured, unclear eligibility, weak continuity planning and activity reporting that does not show durable change.",
    deliverables: [
      "Community baseline and needs assessment",
      "CSR eligibility review and project design",
      "Implementation partner diligence and operating model",
      "Waste worker inclusion and safeguarding framework",
      "Outcome indicators, monitoring and independent impact assessment support",
    ],
    technology: "A monitoring workspace can bring baseline data, field records, outcome indicators and review evidence together.",
    nextStep: "Design your waste-focused CSR project",
  },
];

export const AUDIENCES = [
  {
    id: "producers",
    label: "Producers, brands & exporters",
    heading: "Connect compliance with your material strategy.",
    body: "Map the obligations attached to your products and markets, improve the data behind your returns, and assess opportunities in take-back, reuse and recycled materials.",
    bullets: ["Entity and market obligation map", "Target and cost assessment", "Certificate procurement plan", "Circularity opportunity roadmap"],
    link: "/practice/india-and-global-epr",
    cta: "View EPR advisory",
  },
  {
    id: "municipalities",
    label: "Municipalities & local bodies",
    heading: "Deliver compliant, verifiable city waste services.",
    body: "Build a clear baseline, design workable segregation and processing systems, and monitor service delivery with evidence.",
    bullets: ["Waste characterisation baseline", "Processing facility plans", "Service-level tracking", "Bulk generator programme design"],
    link: "/practice/solid-waste-management",
    cta: "View solid waste advisory",
  },
  {
    id: "bwgs",
    label: "Bulk waste generators",
    heading: "Clear accountability for campus and property waste.",
    body: "Establish the right processing pathway, train the people running it and keep records that show where every stream went.",
    bullets: ["Applicability gap audit", "Wet-waste pathway evaluation", "Daily gate log and destination checks", "Audit-ready reporting"],
    link: "/practice/bulk-waste-generators",
    cta: "View BWG advisory",
  },
  {
    id: "csr",
    label: "CSR teams & foundations",
    heading: "Targeted community programmes with durable continuity.",
    body: "Start with the need, design the operating model and measure outcomes that remain visible after the initial funding cycle.",
    bullets: ["Community needs assessment", "Continuity budget", "Outcome indicator baseline", "Eligibility separation"],
    link: "/practice/waste-management-csr",
    cta: "View CSR advisory",
  },
];

export const TECH_PILLARS = [
  { num: "01", title: "Obligations & deadlines", desc: "Responsibilities, registrations and filing calendars." },
  { num: "02", title: "Data & material records", desc: "Product data, packaging masters and activity records." },
  { num: "03", title: "Certificates & cost visibility", desc: "Procurement records, balances and liability forecasts." },
  { num: "04", title: "Evidence & reporting", desc: "Documentation that supports review and follow-through." },
];

export const TECH_TABS = {
  epr: {
    label: "EPR",
    title: "Compliance overview · Illustrative month",
    metrics: [
      { label: "Entities tracked", value: "03", note: "One consolidated register" },
      { label: "Actions completed", value: "09 / 12", note: "Three awaiting follow-up" },
      { label: "Evidence records", value: "37", note: "Linked to the relevant action" },
    ],
    rows: [
      ["Packaging data reconciliation", "Client team", "In review"],
      ["Certificate provenance check", "CLYMACO", "Scheduled"],
      ["Return preparation", "Joint", "Input needed"],
    ],
  },
  bwg: {
    label: "BWG",
    title: "Campus log · Illustrative month",
    metrics: [
      { label: "Sites active", value: "08", note: "Across three municipalities" },
      { label: "Collections checked", value: "96%", note: "Gate records reviewed" },
      { label: "Open actions", value: "05", note: "Assigned to site owners" },
    ],
    rows: [
      ["Wet-waste processing check", "Site team", "Compliant"],
      ["Dry waste destination review", "CLYMACO", "Verified"],
      ["Municipal return preparation", "Joint", "Due soon"],
    ],
  },
  csr: {
    label: "CSR",
    title: "Community monitor · Illustrative cohort",
    metrics: [
      { label: "Locations reviewed", value: "12", note: "Field records connected" },
      { label: "Indicators on track", value: "08 / 10", note: "Against baseline" },
      { label: "Evidence packs", value: "24", note: "Ready for review" },
    ],
    rows: [
      ["Quarterly monitoring review", "Field team", "Under review"],
      ["Worker inclusion check", "CSR team", "Completed"],
      ["Impact assessment preparation", "CLYMACO", "Scheduled"],
    ],
  },
};

export const APPROACH = [
  { phase: "01 / Understand", name: "Diagnose", desc: "Establish the baseline, applicable obligations, operational gaps and stakeholders.", output: "Baseline and priority map" },
  { phase: "02 / Plan", name: "Design", desc: "Define the intervention, economics, responsibilities, controls and measures of success.", output: "Implementation roadmap" },
  { phase: "03 / Put into practice", name: "Enable", desc: "Support onboarding, documentation, training and delivery through the agreed service providers.", output: "Systems and procedures" },
  { phase: "04 / Follow through", name: "Measure", desc: "Track performance, review evidence and refine the programme as conditions change.", output: "Reporting and improvement plan" },
];

export const ENGAGEMENTS = [
  { tag: "Understand your position", title: "Diagnostic review", desc: "An EPR obligation map, site waste audit, BWG assessment or circularity opportunity review with prioritised next steps." },
  { tag: "Build a programme", title: "Project mandate", desc: "A municipal waste plan, BWG programme, reverse supply chain or waste-focused CSR project with defined outputs and milestones." },
  { tag: "Maintain progress", title: "Ongoing advisory", desc: "Continuing compliance support, service oversight, reporting and performance reviews under an agreed scope." },
];

export const FAQS = [
  ["Can we engage CLYMACO for solid waste work alone?", "Yes. Solid Waste Management and Bulk Waste Generator advisory are distinct practices. A project can cover one establishment, a portfolio of sites or a municipal programme without an EPR mandate."],
  ["Does all streams mean the same rules apply everywhere?", "No. India EPR work covers the applicable streams identified in scope. International obligations are assessed by destination, product, entity and sales model."],
  ["Does waste generation automatically create certificate revenue?", "No. Eligibility, processing, registration, evidence and the applicable scheme determine whether certificates can be generated or traded. Revenue is assessed through a project-specific business case."],
  ["Can routine compliance expenditure be treated as CSR?", "Activities carried out to meet other statutory obligations are excluded from CSR under the CSR Rules. We assess project eligibility separately and design community programmes with their own objectives, budgets and measures of impact."],
  ["Who handles collection and plant operations?", "Operational responsibilities are agreed in the mandate. CLYMACO's advisory role can include system design, service provider selection, procedures and monitoring, with collection, transport and processing undertaken by the designated service providers."],
];

export const SAMPLE_BRIEFINGS = [
  {
    slug: "bwg-briefing",
    category: "Solid waste & BWGs",
    draft: true,
    date: "25 September 2026",
    author: "CLYMACO",
    title: "Bulk waste generators: start with the system, then build the dashboard.",
    excerpt: "Five questions to resolve before digitising a building's or municipality's waste programme.",
    image: IMAGES.sorting,
    body: `A dashboard is useful when it reflects a defined process. Before adding software to a bulk waste programme, establish what is generated, who handles it, where it goes and what evidence is retained.

## Resolve five questions first

- **Who is in scope?** Identify the establishments, assess BWG applicability and assign a responsible person at each site.
- **What is the baseline?** Record waste quantities and composition, collection frequency, segregation quality and existing processing arrangements.
- **What happens to each stream?** Define storage, handover, transport and destination. Assess wet-waste processing and the applicable pathway.
- **Who verifies the outcome?** Specify service provider checks, measurement methods and the documents needed to support the records.
- **What should trigger action?** Agree which gaps need follow-up, who owns them and when they must be closed.

The SWM Rules, 2026 introduce four-stream segregation and a distinct responsibility framework for bulk waste generators. On-site wet-waste processing and approved arrangements must be evaluated under the applicable rules and local requirements.

Once the workflow is clear, a digital layer can connect generator records, collections, destinations and unresolved actions. Its purpose is to make responsibility visible and follow-up easier.

Regulatory reference: MoEFCC overview of the Solid Waste Management Rules, 2026.`,
  },
  {
    slug: "csr-briefing",
    category: "CSR & circularity",
    draft: true,
    date: "25 September 2026",
    author: "CLYMACO",
    title: "Design waste-focused CSR around outcomes that last.",
    excerpt: "Build the baseline, delivery model and continuity plan before choosing the intervention.",
    image: IMAGES.materials,
    body: `A collection drive may be a useful activity. A durable waste-management programme also needs local participation, a viable delivery provider and a plan for what happens when the initial funding ends.

## Begin with a measured need

Establish a baseline with the community. Identify service gaps, current waste destinations and barriers to participation. Use this evidence to select an intervention rather than choosing equipment before understanding the problem.

## Design the operating model

Set responsibilities for collection, processing, maintenance and reporting. Test the recurring cost, identify who will meet it, and assess implementation providers against their actual capacity.

## Measure change, not just activity

Track service adoption, segregation quality, verified recovery and relevant livelihood outcomes against the baseline. Keep records that make these results reviewable. Plan independent impact assessment where required.

## Keep project eligibility clear

Activities carried out to fulfil other statutory obligations are excluded from CSR under the CSR Rules. A community project therefore needs a distinct eligibility review, objectives, budget and outcome framework.

Regulatory reference: Ministry of Corporate Affairs, CSR FAQs, General Circular 14/2021.`,
  },
];

export const PRACTICE_REDIRECTS = {
  "global-epr-for-exporters": "india-and-global-epr",
  "india-epr-compliance": "india-and-global-epr",
  "reuse-recycled-content-take-back": "circular-economy-advisory",
  "circular-economy-reverse-supply-chain": "circular-economy-advisory",
  "data-diligence-traceability": "india-and-global-epr",
  "impact-assessment-csr-project-design": "waste-management-csr",
};
